import React from 'react';

const DeleteIcon = ({ width = 16, height = 16, fill = "#F04F4F" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7325 6.39884C12.7325 6.21484 12.5831 6.06551 12.3991 6.06551H3.60179C3.41712 6.06551 3.26845 6.21484 3.26845 6.39884C3.26845 7.06351 3.25645 7.68284 3.24512 8.25684C3.19579 10.7562 3.16312 12.4075 4.17312 13.4375C4.89045 14.1688 6.06845 14.4955 7.99312 14.4955C9.91979 14.4955 11.0998 14.1682 11.8191 13.4355C12.8338 12.4008 12.8018 10.7415 12.7545 8.22818C12.7438 7.66218 12.7325 7.05218 12.7325 6.39884Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3831 3.85004H10.6225C10.5951 3.41404 10.4745 2.79937 10.0405 2.3007C9.58179 1.77337 8.89512 1.50537 7.99912 1.50537C7.10379 1.50537 6.41712 1.77337 5.95846 2.3007C5.52446 2.79937 5.40312 3.41404 5.37579 3.85004H2.61646C2.34046 3.85004 2.11646 4.07404 2.11646 4.35004C2.11646 4.62604 2.34046 4.85004 2.61646 4.85004H13.3831C13.6591 4.85004 13.8831 4.62604 13.8831 4.35004C13.8831 4.07404 13.6591 3.85004 13.3831 3.85004Z"
      fill={fill}
    />
  </svg>
);

export default DeleteIcon;